import { Button, Card } from '@mui/material';
import { Column, Row } from 'Components/Grid';
import { ReactComponent as CopyIcon } from './../../../../assets/copy_icon.svg';

export const CopyCodeContent = ({ id, copyCode }) => {
  return (
    <>
      <Row>
        <Column
          xs={12}
          flex
          style={{
            alignItems: 'center',
            marginBlock: '16px',
          }}
        >
          <div
            style={{
              width: '100%',
              height: '1px',
              backgroundColor: '#d1d5db',
              border: '1px solid #e5e7eb',
            }}
          ></div>
          <span style={{ fontSize: '14px', fontWeight: '400', marginInline: '12px', textWrap: 'nowrap' }}>
            Copiar código
          </span>
          <div
            style={{
              width: '100%',
              height: '1px',
              backgroundColor: '#d1d5db',
              border: '1px solid #e5e7eb',
            }}
          ></div>
        </Column>
      </Row>
      <Row>
        <Column xs={12}>
          <Card
            sx={{
              backgroundColor: '#f9fafb',
              padding: '12px 24px',
              boxShadow: 'none',
              border: '1px solid #ccc',
            }}
          >
            <Row>
              <Column xs={10}>
                <span id="scriptToCopy" style={{ fontSize: '14px' }}>
                  {`<meta name="adopt-website-id" content="${id}" />`}
                  <br />
                  {`<script
                    src="//tag.goadopt.io/injector.js?website_code=${id}"
                    className="adopt-injector"
                  ></script>`}
                </span>
              </Column>
              <Column xs={2} style={{ display: 'flex', justifyContent: 'end' }}>
                <Button
                  variant="contained"
                  startIcon={<CopyIcon width="22px" height="24px" style={{ padding: '2px' }} />}
                  size="small"
                  onClick={() => {
                    copyCode();
                  }}
                >
                  Copiar
                </Button>
              </Column>
            </Row>
          </Card>
        </Column>
      </Row>
    </>
  );
};
